<template>
  <div class='news-template'>
    <div class="YTitle">消息模板</div>

    <div class="from">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="消息标题：">
          <el-input v-model.trim="formInline.title" placeholder="请输入关键字"></el-input>
        </el-form-item>
        <el-form-item class="YButtonRight">
          <el-button @click="reset" plain round>重置</el-button>
          <el-button type="primary" @click="inquire" round>查询</el-button>
          <el-button type="success" @click="add" round>新增消息模板</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table YTable">
      <el-table
        :data="TableData"
        v-loading="loading"
        border
        height='100%'
        style="width: 100%">
        <el-table-column
          v-for="(item, index) in TableHead"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          show-overflow-tooltip
          align='center'>
        </el-table-column>
        <el-table-column
          align='center'
          label="操作">
          <template slot-scope="scope">
            <el-button @click="details(scope.row)" type="text" size="small">详情</el-button>
            <el-button @click="compile(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="cancel(scope.row)" type="text" size="small"><span style="color: #f56c6c">删除</span></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <YPagination
      :pageNum='pageNum'
      :pageSize='pageSize'
      :Total='Total'
      @SizeChange='SizeChange'
      @CurrentChange='CurrentChange'>
    </YPagination>

    <!-- 新增消息模板 -->
    <Add v-if="AddShow" @close='close'></Add>

    <Edit v-if="EditShow" @close='close' :EditValue='EditValue'></Edit>

    <Details v-if="DetailsShow" @close='close' :DetailsValue='DetailsValue'></Details>
  </div>
</template>

<script>
import Add from './components/add'
import Edit from './components/edit'
import Details from './components/details'
import api from '@/shared/api/apps/news'
export default {
  name: 'newsTemplate',

  components: { Add, Edit, Details },

  data () {
    return {
      AddShow: false,
      EditShow: false,
      EditValue: {},
      DetailsShow: false,
      DetailsValue: {},
      pageNum: 1,
      pageSize: 10,
      Total: 0,
      loading: false,
      formInline: {
        title: ''
      },
      TableHead: [
        {
          prop: 'id',
          label: 'ID'
        },
        {
          prop: 'notifyTitle',
          label: '消息标题'
        },
        {
          prop: 'notifyType.name',
          label: '消息类型'
        }
      ],
      TableData: []
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    init () {
      this.getData()
    },

    getData () {
      const params = {
        method: api.list,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        title: this.formInline.title
      }

      this.loading = true
      this.axios.post(params).then(res => {
        this.loading = false
        if (res.data.backend_odc_notify_template_page_list_response.code !== '10000') return
        this.TableData = res.data.backend_odc_notify_template_page_list_response.result.records
        this.Total = parseInt(res.data.backend_odc_notify_template_page_list_response.result.total)
      })
    },

    details (val) {
      this.DetailsShow = true
      this.DetailsValue = val
    },

    compile (val) {
      this.EditValue = val
      this.EditShow = true
    },

    cancel (val) {
      const params = {
        method: api.delete,
        id: val.id
      }

      this.axios.post(params).then(res => {
        if (res.data.backend_odc_notify_template_delete_response.code !== '10000') return
        this.$message({
          message: '消息模板删除成功',
          type: 'success'
        })
        this.getData()
      })
    },

    reset () {
      this.formInline.flowName = ''
      this.pageNum = 1
      this.getData()
    },

    inquire () {
      this.getData()
    },

    add () {
      this.AddShow = true
    },

    SizeChange (val) {
      this.pageSize = val
      this.pageNum = 1
      this.getData()
    },

    CurrentChange (val) {
      this.pageNum = val
      this.getData()
    },

    close (val) {
      this.AddShow = false
      this.EditShow = false
      this.DetailsShow = false
      if (val !== 1) return
      this.getData()
    }
  }
}
</script>

<style lang='stylus' scoped>
  .news-template
    position relative
    width 100%
    height 100%
    display flex
    flex-direction column
    .table
      flex auto
      overflow auto
      margin-bottom 20px
</style>
